import moment from "moment";
import Cookie from "js-cookie";
let lang = Cookie.get("lang") ? Cookie.get("lang") : "en";
moment.locale(lang);

export default moment;
